module.exports = __webpack_public_path__ + "img/moto.fca4b105.webp";